module.exports = __webpack_public_path__ + "static/img/6.94297dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity/6.png
// module id = AscF
// module chunks = 0